import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EJsonQueryReadyBusinessType } from '../../../packages/api-models/common/json_query';

export const selectReadyBusinessTypes = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('ready_business_types')(jsonQuery) as EJsonQueryReadyBusinessType[] | null,
);
